// REL_1.1.14 F-262 / S-980 — Catch-all 404 page for unknown routes.
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page not found — Deedo</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <section className="flex min-h-[60vh] items-center justify-center px-4">
        <div className="text-center">
          <h1 className="mb-3 text-3xl font-bold text-gray-900">Page not found</h1>
          <p className="mb-6 text-sm text-gray-500">
            The page you&apos;re looking for doesn&apos;t exist.
          </p>
          <Link to="/" className="text-blue-600 hover:underline">
            ← Back to home
          </Link>
        </div>
      </section>
    </>
  );
}
